import {useEffect, useState} from 'react'
import { KTSVG } from '../../../../../../_metronic/helpers'
import {useFormik} from 'formik'
import { is } from 'immutable';
import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';

type Props = {
    togglePermissionEdit:any,
    roleDetails: any,
    permissionList: any
}

const RoleAddEditPermissions: React.FC<Props> = ({togglePermissionEdit, roleDetails, permissionList}) => {
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState(Array<string>());

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const handleSubmit = async (e : any) => {

  e.preventDefault();
  setIsSubmitting(true);
  
  try 
  {
    
    // if(!isUpdate){
    //   // create process
    //   const response = 
    //   await fetch(process.env.REACT_APP_API_URL_BACKEND + '/role/create', 
    //   {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(formData),
    //   });
    // }
    // else
    // {
    //   // update process
    //   formData["role_id"] = formData.id; //have to add permission_id, because form input name was not affecting post value name
    //   const response = 
    //   await fetch(process.env.REACT_APP_API_URL_BACKEND + '/role/update', 
    //   {
    //     method: 'PUT',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(formData),
    //   });
    // }

    togglePermissionEdit(null);    
  } 
  catch (error) 
  {
    console.log(error);
  }
};

const handleChange = (e : any) => {

  const permission:string = e.target.value;
  if (e.target.checked) {
    console.log(e.target.checked);
    console.log(selectedPermissions);
    console.log(permission);
    setSelectedPermissions([...selectedPermissions, permission]);
  } else {
    console.log("not checked");
    setSelectedPermissions(selectedPermissions.filter((p) => p !== permission));
  }
  console.log(selectedPermissions);

};


  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'>
        <form id='kt_modal_add_role_form' onSubmit={handleSubmit} className='form' noValidate>
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            {/* <UserEditModalHeader /> */}
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bold'>
                {"Update Permissions for [" + roleDetails.name + "]"}  
              </h2>
              {/* end::Modal title */}

              {/* begin::Close */}
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={() => togglePermissionEdit(null)}
                style={{cursor: 'pointer'}}>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>

            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              {/* <UserEditModalFormWrapper /> */}
              
              <div className='fv-row mb-7'>
                <div className='display-grid'>              
                {/* hidden field is for id if the modal is open in Update mode */}
                <input type="hidden" name="role_id" value={roleDetails.id} onChange={handleChange}/>  
                {permissionList.map((permission:any) => (
                  <div key={`permission-${permission.id}`}>
                    <input type="checkbox" name={permission.name} value={permission.id} className='form-control form-check-input mb-lg-0' onChange={handleChange} />
                    <label>{permission.name}</label>
                  </div>
                ))}
                </div>
              </div>

              <button
                type='reset'
                onClick={() => togglePermissionEdit(null)}
                className='btn btn-light me-3'
                data-kt-users-modal-action='cancel'
              >
                Discard
              </button>

              <button
              type='submit'
              className='btn btn-primary'
              data-kt-users-modal-action='submit'
              disabled={isSubmitting}>
              <span className='indicator-label'>Update</span>
              </button>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
        </form>      
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {RoleAddEditPermissions}
